// extracted by mini-css-extract-plugin
module.exports = {"video-container":"_3dXjv","videoContainer":"_3dXjv","video-poster":"_36AyC","videoPoster":"_36AyC","video-poster-img":"a2kfA","videoPosterImg":"a2kfA","video":"_3owv4"};